import React from "react";
import { Helmet } from "react-helmet-async";
import { Typography, Dialog, Button, Box, Stack } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import DialogIcon from "src/public/assets/icons/mobile/icons/SadLogoSmall.png";

const MobileWarningPopup = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  return (
    <>
          <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap"
          rel="stylesheet"
        />
      </Helmet>
<Dialog
  open
  fullWidth
  PaperProps={{
    style: {
      borderRadius: 16,
      padding: "30px",
      maxWidth: 360,
      margin: "0 auto",
      boxShadow: "6px 9px 19.1px rgba(122, 136, 145, 0.7)",
    },
  }}
>

      <Stack spacing={2} alignItems="center" textAlign="center">
        <img
          src={DialogIcon}
          alt="Mobile not supported"
          style={{ width: 60, height: 55 }}
        />

        <Typography variant="h6" fontWeight={900} color="#2F3D4A" sx={{letterSpacing: "-0.01em", fontFamily: "'Lato', sans-serif",}}>
          Mobile Not Supported
        </Typography>

  <Stack spacing={.25} textAlign="center">
  <Typography variant="body2" color="#395465">
    For the best experience, please use a desktop or tablet browser.
  </Typography>
  <Typography variant="body2" color="#395465">
    We’re working hard to support mobile soon!
  </Typography>
</Stack>

        <Box width="100%" display="flex" justifyContent="center" mt={1}>
          <Button
            onClick={handleLogout}
            variant="contained"
            sx={{
              borderRadius: 1,
              paddingY: 1.5,
              paddingX: 9,
              fontWeight: 900,
              fontSize: 15,
              textTransform: "none",
              backgroundColor: "#FF9490",
              marginTop: 1.5,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              letterSpacing: "-0.005em", 
              fontFamily: "'Lato', sans-serif",
              "&:hover": {
                backgroundColor: "#ff7f7a",
              },
            }}
          >
            Log Out
          </Button>
        </Box>
      </Stack>
    </Dialog>
    </>
  );
};

export default MobileWarningPopup;